import { _, React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type BacktestDrawdownProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params;
  setParams: (_p: DraftParams) => void;
  title: string;

  fullScreen?: boolean;
  context?: ts.types.backtest.BacktestAnaylsisContext;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'backtest_drawdown', string>;
};

const BacktestDrawdown = ({
  id,
  readOnly,
  widgetKey,
  loadWidgetData,
  widgetPaths,
  params,
  setParams,
  mode,
  fullScreen,
  context,
  title,
}: BacktestDrawdownProps) => {
  const hasBenchmark = React.useMemo(
    () => (params.isBasket ? context?.definition?.optimizer_rebalance : !_.isEmpty(context?.definition?.benchmark)),
    []
  );

  const chart = () => (
    <Chart
      id={id}
      readOnly={readOnly}
      widgetKey={widgetKey}
      params={params}
      fullScreen={fullScreen}
      loadWidgetData={loadWidgetData}
      hasBenchmark={hasBenchmark}
      portfolios={widgetPaths['backtest_drawdown']}
      scale={ts.enums.SCALE_ENUM.LINEAR}
      title={title}
    />
  );

  return (
    <>{mode == 'edit' ? <Form params={params} setParams={setParams} hasBenchmark={hasBenchmark} /> : <>{chart()}</>}</>
  );
};

export default BacktestDrawdown;
